export const tarotList = [
  {
    id: 1,
    name: 'Краткий прогноз (4 карты)',
    description: `Тематика вопроса для этого расклада может быть абсолютно любой - работа, отношения, путешествие, покупка, продажа и т.д. Если вы хотите знать, чем закончится та или иная ситуация или любое важное для вас событие, можете смело использовать это гадание. Результатом расклада будет описание конечного результата с одной уточняющей картой. Как использовать эту уточняющую карту и описание всех позиций вы можете увидеть ниже в самом раскладе.\n\nПримерные темы для вопросов: помиримся ли мы с таким-то человеком, какими будут для меня отношения с N, будет ли для меня успешным этот месяц, окончится ли для меня успешно то, что задумал(а) и т.д. Можно ограничивать вопрос временным отрезком. Например, исполнится ли на этой неделе мое желание, поеду ли я на море этим летом, как будут развиваться мои отношения с N в ближайшие 30 дней.\n\nДля начала гадания нужно выбрать его настройки. Во-первых, определитесь с колодой для гадания. Если хотите видеть для каждой новой позиции случайную карту из всех представленных колод, отметьте пункт "случайно". Во-вторых, выберите способ вытягивания карт. Можете тянуть все четыре карты сами или сосредоточившись на вопросе нажать на колоду только один раз, после чего сразу откроются все карты в раскладе. Отметив все настройки, задайте вопрос и приступите к гаданию.`,
  },
  {
    id: 2,
    name: 'Общий прогноз (3 карты)',
    description: `Небольшой расклад из 3 карт, позволяющий сделать общий прогноз на самые главные события вашей жизни в загаданный период времени: сутки, неделю, месяц и т.д. Будет дана общая характеристика ваших будущих дел, описание самых главных и ярких событий в личной жизни и прогноз на материальную сферу в этот период времени - деньги, недвижимость, работа, карьера. Как вы видите, это довольно простой, но точный расклад, позволяющий увидеть основное течение вашей жизни на интересующем вас отрезке времени.\n\nПримерные вопросы для этого гадания. Как будут идти мои дела в этом месяце? Каким будет для меня текущий год? Что случится со мной сегодня? Как будет проходить моя поездка? Можно интересоваться не только своим будущим, но и делами других людей. Например, что произойдёт с N в ближайшие выходные? Успешна ли будет для N новая работа?\n\nПеред началом гадания нужно определиться с его настройками: выбрать карты для расклада и способ их вытягивания. При выборе пункта "случайно", карты для каждой новой позиции в раскладе будут выбираться случайным образом из всех представленных перед вами колод. Сами карты вы можете тянуть по одной, нажимая каждый раз на анимированную колоду карт, либо нажать на колоду только один раз, после чего откроются все карты расклада. Разницы между этими двумя вариантами нет, в обоих случаях судьба уже знает что вам показать. Разве что второй способ будет чуть быстрее. После выбора всех настроек, задайте ваш вопрос и приступите к самомму гаданию.`,
  },
  {
    id: 3,
    name: 'Кельтский крест (10 карт)',
    description: `Один из самых известных раскладов по предсказанию будущего. Если хотите получить развернутый ответ на ваш вопрос, смело используйте это гадание. Вам откроется ближайшее и отдаленное будущее, причины возможных трудностей, влияние на вас окружающих людей и многое другое.\n\nТема вопросов для данного гадания может быть абсолютно любая: любовь, карьера, дела любого рода и т.д. Одним словом, расклад предсказывает перспективы и итог интересующего нас вопроса; как все пойдет и чем все закончится.`,
  },
  {
    id: 4,
    name: 'Подкова (7 карт)',
    description: `Это онлайн гадание показывает путь от настоящего к будущему и ожидающие Вас на этом пути события. Отличный расклад с подробным описанием прошлого, будущего и полезными рекомендациями по оптимальной линии поведения. В процессе гадания Вам необходимо будет вытянуть 7 карт. Нужную колоду вы можете отметить в настройках расклада.\n\nПостарайтесь расслабиться и полностью сосредоточиться на своем вопросе. Его не обязательно произносить вслух, но лучше сформулировать как можно конкретнее.`,
  },
  {
    id: 5,
    name: 'Алхимик (6 карт)',
    description: `Это, скорее всего, наиболее удобный расклад на будущее, позволяющий максимально подробно рассмотреть все этапы интересующего вас вопроса. Это старинный расклад, появившийся в конце средних веков. Считается, он был изобретен самим Нострадамусом, поэтому он имеет глубоко мистическую окраску. Многие используют его чтобы узнать свою судьбу, раскрыть для себя наиболее значимые события своей жизни, увидеть самые важные этапы на каком-то конкретном промежутке времени. Расклад можно использовать и в менее глобальных вопросах с более конкретной темой: будущее в личной жизни, карьерные перспективы, узнать своё будущее на месяц, год и др.\n\nПримерные темы для расклада. Что случится со мной на этой неделе? Как будут развиваться мои отношения с N в ближайшие пол года? Как будет складываться для меня ситуация на работе в текущем месяце? Каким будет моё здоровье в этом году? Как я уже писал на страницах других гаданий, практически все расклады можно использовать и на других людях. Например, как в этом месяце будут складываться отношения S с L? Что случиться с T в ближайшие 20 дней?\n\nДавайте кратко разберем все позиции этого расклада. Прошлое опишет результат всех событий в жизни человека до сего дня. Настоящее опишет положение вещей на данный момент. Будущее покажет общее состояние дел от текущего момента до самого последнего дня загаданного периода, что будет в общем и целом. Ближашее будущее укажет те события, которые произойдут в жизни человека в очень близком будущем. Промежуточное будущее скажет о тех событиях, которые произойдут в течении нескольких последующих лет (месяцев, дней). Отдаленное будущее указывает на события, которые случатся в конце жизни человека (в конце загаданного периода времени).`,
  },
  {
    id: 6,
    name: 'Тайна верховной жрицы (9 карт)',
    description: `Гадание используется для изучения всего скрытого и малопонятного. Привлекательность этого гадания заключается в том, что оно не только показывает тенденции и перспективы развития, но и дает ответ на мучительный вопрос: "Почему это случилось?", "Что кроется за этим событием, какие тайные силы действуют?". Это один из самых лучших раскладов на будущее, он полность раскладывает по полочкам все происходящие события.\n\nДля этого гадания Вам нужно вытянуть 9 карт. Постарайтесь расслабиться и полностью сосредоточиться на своем вопросе. Его не обязательно произносить вслух, но лучше сформулировать как можно конкретнее.`,
  },
  {
    id: 7,
    name: 'Выбор оптимального решения (9 карт)',
    description: `Если перед вами стоит выбор между двумя различными вариантами, и вы не знаете как поступить - воспользуйтесь именно этим онлайн раскладом. Например, ехать куда-то или не ехать, переходить на новую работу или нет, разрывать отношения с человеком или пока остаться с ним. То есть это гадание работает в том случае, когда есть положительное и отрицательное решение. Дополнительно это гадание раскроет события, которые вы недостаточно серьезно приняли во внимание и которые будут иметь более серьезное влияние на ваше будущее. Одновременно с эти вам раскроют те факторы, значение которых вами было преувеличено и которые не будут оказывать большого внимания на исход дела.\n\nВарианты вопросов: Ехать ли мне искать работу в город "N"? Выходить ли мне замуж за "NN"? Покупать ли мне сейчас новый автомобиль? Что будет, если я сыграю в лотерею? Для моего более лучшего будущего нужно ли мне открывать свое дело или следует остаться на старой работе?\n\nВ некоторых случаях есть два конкретных варианта, из которых вы не можете выбрать какой-то один. Это может быть выбор между двумя работами, двумя людьми, двумя покупками. Например: Выходить ли мне замуж за Сергея или Олега? Покупать ли мне "NNN" или "ZZZ"? Подобные вопросы не рекомендуется задавать. Лучше сначала задать вопрос с Сергеем, а потом с Олегом. В этом случае перед вами будет более точная картина.`,
  },
  {
    id: 8,
    name: 'Судьба и будущее (8 карт)',
    description: `Еще одно удобное онлайн гадание для прояснения нашего будущего. Наверное, многие из нас задавались однажды вопросом - что такое судьба? Думаю тут можно выделить два момента. Первое - это те эпизоды нашей жизни, которые оставляют максимально яркие и заметные следы в нашей памяти. И второй пункт - это события, которые обязательно должны с нами произойти, мы будем не в силах обойти это стороной, даже если очень сильно захотим. Этот расклад даст нам понять что именно записано в небесной книге касательно нашего вопроса. Помимо этого, гадание откроет наше ближайшее и отдаленное будущее. Подробное описание всех пунктов смотрите в самом раскладе. Если все эти карты будут показывать логичную и понятную картину, значит ваше будущее в этом направлении окончательно сформировано, и мы можем наблюдать его в данном онлайн гадании.\n\nЭто расклад на будущее, поэтому вопросы должны задаваться именно в этом ключе. Найду ли я в этом году новую работу? Выйду ли я в этом году замуж? Будут ли у меня в ближайшие три года дети? Закончится ли в этом году война? Дадут ди мне завтра кредит?`,
  },
];

export const categories = [
  {
    id: 1,
    categories: [
    {
      name: 'Есть ли помеха в настоящем',
      description: 'Что мешает в данный момент реализации ваших замыслов. Хорошая карта говорит о том, что помех на вашем пути нет',
    },
    {
      name: 'Будет ли помеха в будущем',
      description: 'Если до этого была помеха, в будущем она может исчезнуть. И наоборот, если раньше всё было хорошо, потом могут появиться трудности',
    },
    {
      name: 'Результат, будущее, ответ на ваш вопрос',
      description: null,
    },
    {
      name: 'Совет, объяснение, пояснение по поводу будущего',
      description: 'Эта карта может дополнительно внести ясность и прояснить ситуацию по поводу будущего. Можете использовать её только в случае крайне непонятного предыдущего ответа'
    },
  ]
  },
  {
    id: 2,
    categories: [
      {
        name: 'Общий прогноз на загаданный период времени',
        description: 'Общая характеристика будущих событий, что будет преобладать',
      },
      {
        name: 'Что вас ждет в личной жизни в этот период',
        description: null,
      },
      {
        name: 'Что вас ждет в материальном плане',
        description: null,
      },
    ]
  },
  {
    id: 3,
    categories: [
      {
        name: 'Что влияет в настоящем на ваш вопрос',
        description: null,
      },
      {
        name: 'Помощь или препятствия',
        description: 'Положительная карта - вы получите помощь, будете сильнее своих врагов. Негативная карта - ждите проблем, враги окажутся сильнее',
      },
      {
        name: 'Мотивация прошлого',
        description: 'Что влияло в прошлом на ваш вопрос, что заставило действовать',
      },
      {
        name: 'Недавнее прошлое',
        description: null,
      },
      {
        name: 'Вероятное будущее',
        description: null,
      },
      {
        name: 'Ближайшее будущее',
        description: null,
      },
      {
        name: 'Ваше отношение к проблеме',
        description: null,
      },
      {
        name: 'Ваше окружение',
        description: 'Как ваше окружение относится ко всему происходящему, как влияет на события. Здесь могут быть родственники, друзья, знакомые, коллеги',
      },
      {
        name: 'Ваши надежды или опасения',
        description: null,
      },
      {
        name: 'Окончательный итог',
        description: null,
      },
    ]
  },
  {
    id: 4,
    categories: [
      {
        name: 'Что влияет из прошлого на настоящее',
        description : null,
      },
      {
        name: 'Настоящее положение вещей',
        description : null,
      },
      {
        name: 'Как будут развиваться события',
        description : null,
      },
      {
        name: 'Наилучшая линия поведения',
        description : null,
      },
      {
        name: 'Влияние и воздействие окружающих на ситуацию',
        description : null,
      },
      {
        name: 'Помехи и препятствия',
        description : null,
      },
      {
        name: 'Итог',
        description : null,
      },
    ]
  },
  {
    id: 5,
    categories: [
      {
        name: 'Прошлое вопрошающего',
        description : null,
      },
      {
        name: 'Настоящее вопрошающего',
        description : null,
      },
      {
        name: 'Будущее вопрошающего',
        description : null,
      },
      {
        name: 'События ближайшего будущего',
        description : null,
      },
      {
        name: 'События промежуточного будущего',
        description : null,
      },
      {
        name: 'События отдаленного будущего',
        description : null,
      },
    ]
  },
  {
    id: 6,
    categories: [
      {
        name: 'Причина, по которой возник вопрос',
        description : null,
      },
      {
        name: 'Активная сила',
        description : 'Сила, которая проводит активные изменения. Именно эти события меняют в настоящее время ваше ближайшее будущее',
      },
      {
        name: 'Полнолуние. Данные события проявляются наиболее явно',
        description : 'Здесь описана ситуация, которая в данный момент является наиболее видимой и ощутимой',
      },
      {
        name: 'Растущая луна. Сила, которая будет нарастать',
        description : 'В какую сторону будет двигаться ситуация. Здесь будет описано или улучшение, или изменение к худшему. Карта хорошо показывает перспективу вашего вопроса',
      },
      {
        name: 'Убывающая луна. Сила, которая будет убывать',
        description : 'Данная ситуация останется в прошлом, проигрывающая сила',
      },
      {
        name: 'Тайная тенденция. То, что скрыто влияет на вопрос',
        description : null,
      },
      {
        name: 'То, что сразу видно в данной ситуации',
        description : 'Описанное в этой позиции сразу бросается в глаза. Можно сказать, это еще одна карта, которая описывает настоящее. Но эти события не столь важны, они могут быть лишь ширмой, маской. Возможно, это специально выставляется напоказ, чтобы скрыть что-то другое. Рекомендуется тщательно изучить предыдущий пункт "Тайная тенденция"',
      },
      {
        name: 'Дальнейший путь. Итог',
        description : null,
      },
      {
        name: 'Тайна. Почему и для чего всё это происходит',
        description : 'Здесь рассматривается только старший аркан. Карта показывает реальное значение происходящих событий. К чему это приведет вас. Из младших арканов рассматриваются только те, которые тесно связаны с вопросом. Младший аркан говорит об отсутствии скрытого смысла, ситуация ясна и понятна',
      }
    ]
  },
  {
    id: 7,
    categories: [
      {
        name: 'Уместно ли положительное решение',
        description : 'Пришло ли время осуществить задуманное',
      },
      {
        name: 'Уместно ли отрицательное решение',
        description : 'Нужно ли именно сейчас воплощать в жизнь отрицательное решение. Может случиться так, что еще не настало время как для положительного, так и для отрицательного решения',
      },
      {
        name: 'Последствия положительного решения',
        description: null,
      },
      {
        name: 'Последствия отрицательного решения',
        description: null,
      },
      {
        name: 'Факторы, не принятые во внимание',
        description: 'Очень важный пункт, нужно обязательно обратить внимание на эту карту. Описанные здесь события и последствия намного важнее, чем вы думаете',
      },
      {
        name: 'Факторы, значимость которых была преувеличена',
        description: 'Отрицательная карта говорит о том, что вы слишком пессимистично настроены. На самом деле трудности не такие уж и серьезные',
      },
      {
        name: 'Результат претворения решения в жизнь',
        description: 'Это отдаленные последствия вашего положительного решения. Вы можете увидеть к чему всё это в итоге приведет и задать себе вопрос: "А нужно ли вам это?" Изначальный результат вашего решения может быть положительный, но в итоге дальнейшие события могут быть не такими радужными. Посмотрите на итоги вашего отрицательного решения. Может быть, они будут более привлекательными',
      }
    ]
  },
  {
    id: 8,
    categories: [
      {
        name: 'Текущая ситуация',
        description: 'Можете проверить расклад на точность по этим двум картам',
      },
      {
        name: 'Ближайшее будущее',
        description: null,
      },
      {
        name: 'Более отдаленное будущее',
        description: null,
      },
      {
        name: 'Судьба',
        description: 'Если здесь негативная карта, то изменить это будет крайне сложно, но возможно. В любом случае изучите совет, который даст вам следующая карта',
      },
      {
        name: 'Совет',
        description: 'Именно это вы должны сделать для достижения задуманного. Если в пунктах "Судьба" и "Совет" выпали негативные карты, то вам лучше оставить это дело, всё равно ничего не получится. Если в положении "Судьба" выпала положительная карта, а здесь плохая, то вам нужно как можно скорее разобраться с описанными негативными событиями и исправить их. Дополнение: почти всегда карта просто описывает будущие события. Она как бы спрашивает: нужно ли стремиться к этому?',
      }
    ]
  }
];